// Module
var code = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"margin:auto;background:0 0;display:block;shape-rendering:auto\" width=\"211px\" height=\"211px\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\"> <circle cx=\"50\" cy=\"50\" r=\"40\" stroke-width=\"12\" stroke=\"#000000\" stroke-dasharray=\"62.83185307179586 62.83185307179586\" fill=\"none\" stroke-linecap=\"round\"> <animateTransform attributeName=\"transform\" type=\"rotate\" repeatCount=\"indefinite\" dur=\"1s\" keyTimes=\"0;1\" values=\"0 50 50;360 50 50\"></animateTransform> </circle> </svg>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-loader-spin.svg
// module id = Q9hP
// module chunks = 34